var exports = {};

function quarticIn(t) {
  return Math.pow(t, 4);
}

exports = quarticIn;
export default exports;